import React, { useState } from 'react';
import { 
  Box,
  Container, 
  TextField, 
  Button, 
  Typography, 
  Paper, 
  CircularProgress,
  Alert,
  Link
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  
  const { requestPasswordReset } = useAuth();

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setSuccess(false);
    setLoading(true);
    
    try {
      await requestPasswordReset(email);
      setSuccess(true);
      setEmail(''); // Clear email field
    } catch (err) {
      setErrorMessage(
        err.response?.data?.detail || 
        err.response?.data?.email?.[0] || 
        'Failed to send reset email. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh'
        }}
      >
        <Paper elevation={3} sx={{ padding: 4, width: '100%' }}>
          <Typography component="h1" variant="h5" align="center" gutterBottom>
            Accrual Management System
          </Typography>
          
          <Typography component="h2" variant="h6" align="center" mb={3}>
            Reset Password
          </Typography>
          
          {success ? (
            <Box>
              <Alert severity="success" sx={{ mb: 2 }}>
                Reset password link has been sent to your email.
              </Alert>
              <Typography variant="body2" align="center" mt={2}>
                <Link component={RouterLink} to="/login" underline="hover">
                  Back to login
                </Link>
              </Typography>
            </Box>
          ) : (
            <>
              <Typography variant="body2" sx={{ mb: 3 }}>
                Enter your email address and we'll send you a link to reset your password.
              </Typography>
              
              {errorMessage && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {errorMessage}
                </Alert>
              )}
              
              <Box component="form" onSubmit={handleSubmit} noValidate>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  value={email}
                  onChange={handleChange}
                  disabled={loading}
                  type="email"
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                  disabled={loading || !email}
                >
                  {loading ? <CircularProgress size={24} /> : 'Send Reset Link'}
                </Button>
                
                <Typography variant="body2" align="center">
                  <Link component={RouterLink} to="/login" underline="hover">
                    Back to login
                  </Link>
                </Typography>
              </Box>
            </>
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default ForgotPassword; 